<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Upsell'"
      [customBack]="'more'"
      [canGoBack]="!windowService.isDesktopRes" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [hasBottomNav]="true">
    <ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'desktop' }" />

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (windowService?.isDesktopRes) {
      <tidy-desktop-header>
        <div class="wrappable-container">
          <tidy-text
            [title]="'Upsell'" />
        </div>
        <div class="non-wrappable-right-aligned-container">
          @if (showLoadingSpinner) {
            <ion-spinner name="lines" class="header-loading-spinner" />
          }
        </div>
      </tidy-desktop-header>
    }

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" [desktopWidthContent]="desktopWidthContent" />
